import { combineReducers } from "redux";
import commonReducer from './commonSlice'
import actAsReducer from './actasSlice'
import authReducer from './authSlice'
import qcReducer from './qcSlice'
import searchReducer from './searchSlice'

export const reducers = combineReducers({
    common: commonReducer,
    actas: actAsReducer,
    auth: authReducer,
    qc: qcReducer,
    search: searchReducer
});
